import { FormEvent, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { MyFooter } from '../landingpage/MyFooter';
import MenuComponent from '../component/MenueComponent';
import { IKategorie } from '../util/types';
import { LoadingModal } from '../component/LoadingModal/LoadingModal';

export type IEreignis = {
  name: string,
}

export function Anmeldung() {

  type IFormError = {
    anrede: string,
    name: string,
    email: string,
    geburtsjahr: string,
    verein: string,
    startkategorie: string,
    check: string,
  }

  type IFormData = {
    anrede: string,
    name: string,
    email: string,
    geburtsjahr: string,
    verein: string,
    startkategorie: string,
    check: boolean,
  }

  const newFormdata: IFormData = {
    anrede: "m",
    name: "",
    email: "",
    geburtsjahr: "",
    verein: "",
    startkategorie: "",
    check: false,
  }

  type IAnswer = {
    "erfolg": string,
    "error": string
  }

  const [ansicht, setAnsicht] = useState<string>("eingabe");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [formId, setFormId] = useState<string>(uuidv4());
  const [formData, setFormData] = useState<IFormData>(newFormdata);
  const [formError, setFormError] = useState<IFormError>();
  const [antwort, setAntwort] = useState<IAnswer>();
  const [kategorien, setKategorien] = useState<IKategorie[]>([]);
  const [ereignis, setEreignis] = useState<IEreignis[]>([]);

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  }

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  }

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  }

  const sendData = (e: FormEvent<HTMLFormElement>) => {

    e.preventDefault();

    if (!formData) return;

    var error: IFormError = {
      anrede: '',
      name: '',
      email: '',
      geburtsjahr: '',
      verein: '',
      startkategorie: '',
      check: ''
    };

    var isError: boolean = false;

    if (!formData.name || formData.name === "") {
      error.name = "Ein Name muss angegeben werden.";
      isError = true;
    }
    if (!formData.email || formData.email === "") {
      error.email = "Eine gültige E-Mail Adresse muss angegeben werden.";
      isError = true;
    }
    if (!formData.geburtsjahr || formData.geburtsjahr === "") {
      error.geburtsjahr = "Ein Geburtsjahr muss angegeben werden.";
      isError = true;
    }
    if (!formData.startkategorie || formData.startkategorie === "0") {
      error.startkategorie = "Startkategorie muss mit angegeben werden.";
      isError = true;
    }
    setFormError(error);
    if (isError) return;

    //
    const dataParam = new URLSearchParams();
    dataParam.append("formId", "" + formId);
    dataParam.append("inputAnrede", "" + formData?.anrede);
    dataParam.append("inputName", "" + formData?.name);
    dataParam.append("inputVerein", "" + formData?.verein);
    dataParam.append("inputEmail", "" + formData?.email);
    dataParam.append("inputGeburtsjahr", "" + formData?.geburtsjahr);
    dataParam.append("inputKategorie", "" + formData?.startkategorie);
    dataParam.append("inputAgree", "" + formData?.check);

    setIsLoading(true);
    fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restAnmeldung.rest"
      , {
        method: "post"
        , headers: {
          'Accept': 'application/json',
          //'Content-Type': 'application/json'
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: dataParam
      }
    )
      .then(resp => resp.json())
      .then(setAntwort)
      .catch(error => alert(error))
      .finally(() => setIsLoading(false))
      ;
  }

  useEffect(() => {
    if (!antwort) return;

    if (antwort?.erfolg === "true") {
      setAnsicht("erfolg");
      setFormId(uuidv4());
      setFormData(newFormdata);
    } else {
      var error: IFormError = {
        anrede: '',
        name: '',
        email: '',
        geburtsjahr: '',
        verein: '',
        startkategorie: '',
        check: ''
      };

      if (antwort?.error === "Anrede ist fehlerhaft!") {
        error.anrede = antwort?.error;
      } else if (antwort?.error === "Ein Name muss angegeben werden.") {
        error.name = antwort?.error;
      } else if (antwort?.error === "Eine gültige E-Mail Adresse muss angegeben werden.") {
        error.email = antwort?.error;
      } else if (antwort?.error.startsWith("Das Geburtsjahr für Kategorie ")) {
        error.geburtsjahr = antwort?.error;
      } else {
        alert("unbekannter fehler! " + antwort?.error);
      }
      setFormError(error);
    }
  }, [antwort]);

  useEffect(() => {
    if (!ansicht) return;

    if (ansicht === "eingabe") {

      fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetAktuelleAnmeldungen.rest")
        .then(response => response.json())
        .then(setEreignis)
        .catch((e) => console.log(e));
    }
  }, [ansicht]);

  useEffect(() => {
    if (!ereignis) return;
    if (ereignis.length !== 0) {
      fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetKategorienAktuell.rest")
        .then(response => response.json())
        .then((data: IKategorie[]) => {
          setKategorien(data);
          if (data.length === 1)
            setFormData((prevData) => ({ ...prevData, startkategorie: "" + data[0].id }));
        })
        .catch((e) => console.log(e));
    }
  }, [ereignis]);

  return (
    <>

      <LoadingModal show={isLoading} />

      <div className="max-w-7xl mx-auto px-4">


          <MenuComponent aktuelleseite="anmeldung" />

          <div className="col-md-12 ml-sm-auto col-lg-12 px-4" role="main">

            {ansicht === "eingabe" &&
              <>

                {ereignis.length === 0 &&
                  <div>Es sind zur Zeit keine Veranstaltungen zur Anmeldung verfügbar.</div>
                }

                {ereignis.length !== 0 &&
                  <div>

                    <p className="max-w text-center text-2xl mt-4">Anmeldung zur Veranstaltung {ereignis[0].name}</p>

                    <div>
                      <table className="table">
                        <caption style={{ "captionSide": "top" }}>Einteilung der Jahrgänge in die U-Kategorien</caption>
                        <thead>
                          <th>Jahrgänge</th>
                          <th>Kategorie</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>2020 - 2021</td>
                            <td>U6</td>
                          </tr>
                          <tr>
                            <td>2018 - 2019</td>
                            <td>U8</td>
                          </tr>
                          <tr>
                            <td>2016 - 2017</td>
                            <td>U10</td>
                          </tr>
                          <tr>
                            <td>2014 - 2015</td>
                            <td>U12</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <form method="post" onSubmit={sendData}>
                      <input type="hidden" name="action" value="submit" />

                      <div className="form-group">
                        <label htmlFor="inputName">Ereignis:</label>
                        <input type="text" className="form-control" readOnly={true} value={ereignis?.at(0)?.name} />
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputAnrede">Anrede:</label>
                        <select className={((formError?.anrede !== undefined && formError?.anrede !== "") ? "is-invalid" : "") + " form-control"} name="anrede" id="anrede" value={formData?.anrede} onChange={handleSelect}>
                          <option value="m" >Herr</option>
                          <option value="w" >Frau</option>
                        </select>
                        <div className='invalid-feedback'>{formError?.anrede}</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputName">Vor- und Nachname:</label>
                        <input type="text" className={((formError?.name !== undefined && formError?.name !== "") ? "is-invalid" : "") + " form-control"} name="name" id="name" value={formData?.name} onChange={handleInput} />
                        <div className='invalid-feedback'>{formError?.name}</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputEmail">E-Mail Adresse:</label>
                        <input type="email" className={((formError?.email !== undefined && formError?.email !== "") ? "is-invalid" : "") + " form-control"} name="email" id="email" placeholder="z.B. max@example.com" value={formData?.email} onChange={handleInput} />
                        <div className='invalid-feedback'>{formError?.email}</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputGeburtsjahr">Ihr Geburtsjahr</label>
                        <input type="text" className={((formError?.geburtsjahr !== undefined && formError?.geburtsjahr !== "") ? "is-invalid" : "") + " form-control"} name="geburtsjahr" id="geburtsjahr" placeholder="JJJJ" value={formData?.geburtsjahr} onChange={handleInput} />
                        <div className='invalid-feedback'>{formError?.geburtsjahr}</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputVerein">Verein / Schule / Kindergarten</label>
                        <input type="text" className={((formError?.verein !== undefined && formError?.verein !== "") ? "is-invalid" : "") + " form-control"} name="verein" id="verein" value={formData?.verein} onChange={handleInput} />
                        <div className='invalid-feedback'>{formError?.verein}</div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="inputKategorie">Startkategorie:</label>
                        <select className={((formError?.startkategorie !== undefined && formError?.startkategorie !== "") ? "is-invalid" : "") + " form-control"} name="startkategorie" id="startkategorie" onChange={handleSelect}>
                          <option value={0}>--- Bitte auswählen ---</option>";
                          {
                            kategorien.map((e) =>
                              <>
                                <option value={e.id}>{e.name}</option>";
                              </>)
                          }
                        </select>
                        <div className='invalid-feedback'>{formError?.startkategorie}</div>
                      </div >

                      <input type="hidden" name="inputGruppe" value="keine" />


                      <p>
                        <br />
                        <b>Anmeldebedingungen:</b>
                        <br />
                        <br />Die eingegebenen Daten ( Anrede, Vor- und Nachnamen, Geburtsjahr und Vereinsnamen )
                        werden zur Veröffentlichung der Rangliste im Internet verwendet. Bei dieser Veranstaltung werden Bild und Tonaufnahmen
                        angefertigt. Mit der Teilnahme an dieser Veranstaltung stimmen Sie der Veröffentlichung dieser Aufnahmen zu.
                        Ihre E-Mailadresse wird für die Versendung von Informationen zu dieser Veranstaltung verwendet.
                      </p>

                      <div className="form-group">
                        <input className="form-check-input " type="checkbox" name="check" id="check" required={true} checked={formData?.check} onChange={handleCheck} />
                        <label className="form-check-label" htmlFor="check">
                          Ich habe die Anmeldebedingungen gelesen und stimme diesen zu.
                        </label>
                        <div className='invalid-feedback'>{formError?.check}</div>
                      </div>

                      <div className="form-group">
                        <input type='submit' className="btn btn-primary" />
                      </div>

                    </form >
                  </div >
                }
              </>}

            {ansicht === "erfolg" &&
              <>
                <h2 style={{ "textAlign": "center", "width": "100%" }}>Erfolgreiche Anmeldung zu {ereignis[0].name}</h2>

                <p>
                  Es wurde eine E-Mail an die von Ihnen angegebene E-Mail Adresse mit Ihrer persönlichen Teilnehmer Identifikationsnummer versendet.
                </p>

                <p>
                  <button className="btn btn-primary" onClick={() => setAnsicht("eingabe")}>
                    Eine weitere Anmeldung eingeben
                  </button>
                </p>
              </>}
          </div>
        </div>

      <MyFooter />
    </>
  );
}

export default Anmeldung;